export const categories = [
  {
    slug: 'identification-methods',
    name: '鉴别方法',
    description: '权威的毒蘑菇鉴别方法汇总，从外观特征到化学反应，全面掌握科学鉴别技巧',
    icon: 'ri-microscope-line',
    articles: ['visual-identification', 'chemical-test', 'spore-print', 'cross-section', 'smell-test', 'insect-bite-myth'],
  },
  {
    slug: 'common-poisonous',
    name: '常见毒蘑菇',
    description: '中国境内最常见的毒蘑菇种类详解，附高清图鉴对比，帮助野外快速识别',
    icon: 'ri-bug-line',
    articles: ['amanita-virosa', 'amanita-phalloides', 'galerina-marginata', 'cortinarius', 'chlorophyllum-molybdites', 'amanita-muscaria'],
  },
  {
    slug: 'first-aid',
    name: '中毒急救',
    description: '蘑菇中毒后的紧急处理步骤、就医指南及康复建议，关键时刻能救命',
    icon: 'ri-heart-pulse-line',
    articles: ['emergency-steps', 'symptoms-timeline', 'hospital-guide', 'home-remedies-myth', 'children-special', 'long-term-recovery'],
  },
  {
    slug: 'foraging-guide',
    name: '采摘指南',
    description: '安全采摘蘑菇的完整指南，从装备准备到采摘技巧，让野外体验更安心',
    icon: 'ri-compass-3-line',
    articles: ['essential-equipment', 'best-seasons', 'safe-harvesting', 'storage-tips', 'regional-guide', 'legal-regulations'],
  },
  {
    slug: 'mushroom-gallery',
    name: '毒蘑菇图鉴',
    description: '高清毒蘑菇图鉴对比，通过可视化方式帮助快速区分有毒与可食用蘑菇',
    icon: 'ri-image-line',
    articles: ['amanita-comparison', 'bolete-comparison', 'russula-comparison', 'agaricus-comparison', 'spring-species', 'autumn-species'],
  },
];

export const allArticles = [
  {
    slug: 'visual-identification',
    title: '外观鉴别法：从菌盖到菌柄的完整观察指南',
    category: 'identification-methods',
    excerpt: '通过观察蘑菇的菌盖形状、颜色、菌褶排列、菌柄特征等外观要素，可以初步判断蘑菇种类。本指南将一步一步教你如何系统性地观察蘑菇外观。',
    content: `<p>外观鉴别法是毒蘑菇测试中最基础也最重要的方法之一。通过仔细观察蘑菇的多个外观特征，我们可以初步判断其种类和是否有毒。</p>
<h2>菌盖观察要点</h2>
<p>菌盖是蘑菇最显眼的部分，也是鉴别的重要依据。需要观察菌盖的形状（伞形、漏斗形、半球形等）、颜色、表面纹理（光滑、鳞片状、黏滑等）、边缘特征（全缘、条纹状等）。</p>
<p>例如，致命白毒伞（Amanita virosa）的菌盖呈纯白色，表面光滑，而可食用的鸡枞菌则呈灰褐色，表面有放射状裂纹。</p>
<h2>菌褶检查</h2>
<p>翻转菌盖观察菌褶的排列方式、颜色和密度。菌褶有离生、弯生、直生等不同着生方式，这些特征对于区分外观相似的种类至关重要。</p>
<h2>菌柄特征</h2>
<p>菌柄的长度、粗细、颜色、表面纹理，以及是否有菌环、菌托等结构，都是关键鉴别点。鹅膏属毒蘑菇的一个典型特征就是同时具有菌环和菌托。</p>`,
    readTime: 8,
    publishDate: '2026-06-15',
  },
  {
    slug: 'chemical-test',
    title: '化学反应测试法：科学验证蘑菇毒性',
    category: 'identification-methods',
    excerpt: '利用简单的化学试剂与蘑菇组织发生反应，通过颜色变化判断蘑菇种类。这种方法比单纯外观观察更加科学准确。',
    content: `<p>化学反应测试法是利用特定化学试剂与蘑菇组织中的化学成分发生反应，根据颜色变化来辅助鉴别蘑菇种类的方法。</p>
<h2>常用试剂介绍</h2>
<p>最常用的试剂包括氢氧化钾（KOH）溶液、硫酸亚铁溶液、梅尔泽试剂等。这些试剂可以与蘑菇组织中的特定化合物反应产生特征颜色。</p>
<h2>测试操作步骤</h2>
<p>用滴管取少量试剂滴在蘑菇的菌盖表面、菌肉或菌褶上，观察颜色变化。不同种类的蘑菇对同一试剂的反应可能完全不同，这是鉴别的重要依据。</p>
<h2>安全注意事项</h2>
<p>化学反应测试虽然科学，但需要具备一定的专业知识。不建议普通人在没有指导的情况下自行操作，最好在有经验的人士指导下进行。</p>`,
    readTime: 10,
    publishDate: '2026-06-20',
  },
  {
    slug: 'spore-print',
    title: '孢子印测试：最简单可靠的鉴别手段',
    category: 'identification-methods',
    excerpt: '孢子印是鉴别蘑菇种类最可靠的方法之一。通过收集蘑菇掉落的孢子，观察其颜色，可以大幅缩小蘑菇种类范围。',
    content: `<p>孢子印测试是毒蘑菇鉴别中最简单、最可靠的方法之一。孢子的颜色是蘑菇分类的重要依据，不同种类的蘑菇孢子颜色各不相同。</p>
<h2>制作孢子印的步骤</h2>
<p>取一个成熟的蘑菇菌盖，将菌褶面朝下放在一张白纸（或一半白一半黑的纸）上。用一个碗或杯子盖住，静置6-12小时。移开菌盖后，纸上留下的孢子图案就是孢子印。</p>
<h2>孢子颜色分类</h2>
<p>常见的孢子颜色有白色、粉色、棕色、紫褐色、黑色等。例如，鹅膏属的孢子通常为白色，而鬼伞属的孢子为黑色。孢子颜色是区分可食用蘑菇和毒蘑菇的关键特征。</p>`,
    readTime: 6,
    publishDate: '2026-07-01',
  },
  {
    slug: 'cross-section',
    title: '切面观察法：菌肉变色揭示毒性信号',
    category: 'identification-methods',
    excerpt: '切开蘑菇观察菌肉颜色变化，某些毒蘑菇切开后会迅速变色，这是重要的毒性警示信号。',
    content: `<p>切面观察法是通过切开蘑菇，观察菌肉颜色变化来判断蘑菇种类和毒性的方法。</p>
<h2>操作步骤</h2>
<p>用干净的小刀将蘑菇纵向切开，观察切面颜色。注意记录切面初始颜色以及在空气中暴露后的颜色变化过程。</p>
<h2>典型变色反应</h2>
<p>某些牛肝菌切开后菌肉会迅速变蓝，这是氧化反应的结果。虽然并非所有变蓝的牛肝菌都有毒，但这是一个需要警惕的信号。裸盖菇属的蘑菇受伤后会变蓝，含有致幻成分。</p>`,
    readTime: 5,
    publishDate: '2026-07-05',
  },
  {
    slug: 'smell-test',
    title: '气味辨别法：用鼻子判断蘑菇安全性',
    category: 'identification-methods',
    excerpt: '不同蘑菇有独特的气味特征，某些毒蘑菇散发特殊气味。学会用嗅觉辅助鉴别，增加判断准确性。',
    content: `<p>气味辨别法是毒蘑菇测试的辅助手段。不同种类的蘑菇具有不同的气味特征，有些毒蘑菇有非常特殊的气味。</p>
<h2>常见蘑菇气味</h2>
<p>有些蘑菇有杏仁味、萝卜味、面粉味等特殊气味。例如，某些毒鹅膏有甜腻的令人不愉快的气味，而食用菌如松茸则有独特的松香味。</p>
<h2>注意事项</h2>
<p>气味辨别不能作为唯一的鉴别依据，需要结合其他方法综合判断。此外，不要直接闻未知蘑菇的粉末，以免吸入孢子引起过敏。</p>`,
    readTime: 5,
    publishDate: '2026-07-10',
  },
  {
    slug: 'insect-bite-myth',
    title: '昆虫叮咬误区：虫子吃过的蘑菇就安全吗？',
    category: 'identification-methods',
    excerpt: '很多人认为被虫子咬过的蘑菇就是安全的，这是最常见的致命误区。事实上，许多剧毒蘑菇同样会被昆虫取食。',
    content: `<p>"虫子能吃，人就能吃"——这是毒蘑菇鉴别中最危险、最致命的误区之一。</p>
<h2>为什么这是错误观念？</h2>
<p>昆虫和人类的生理结构完全不同。昆虫的消化系统和代谢方式与人类差异巨大，对昆虫无害的毒素可能对人类致命。</p>
<h2>典型案例</h2>
<p>致命鹅膏（Amanita phalloides）是世界范围内致死率最高的毒蘑菇，但它的菌盖上经常可以发现被昆虫啃食的痕迹。这说明即使是最毒的蘑菇，昆虫也可以取食而毫发无损。</p>
<h2>安全原则</h2>
<p>切勿以昆虫是否取食作为判断蘑菇可食性的标准。鉴别蘑菇必须依靠科学的方法，综合使用外观观察、孢子印测试等多种手段。</p>`,
    readTime: 7,
    publishDate: '2026-07-15',
  },
  {
    slug: 'amanita-virosa',
    title: '致命白毒伞：中国最常见的致死性毒蘑菇',
    category: 'common-poisonous',
    excerpt: '致命白毒伞（Amanita virosa）是中国蘑菇中毒死亡案例中最常见的元凶，外观洁白无害却剧毒无比。',
    content: `<p>致命白毒伞（学名：Amanita virosa），俗称"毁灭天使"，是中国乃至世界范围内致死率最高的毒蘑菇之一。</p>
<h2>外观特征</h2>
<p>菌盖纯白色，直径5-12厘米，初期半球形后渐平展。菌褶白色，离生。菌柄白色，长8-15厘米，基部有膨大的菌托，上部有膜质菌环。</p>
<h2>毒性成分</h2>
<p>含有鹅膏毒肽（amatoxins），属于肝毒性毒素。即使摄入极少量也可能致死，且毒素耐高温，烹饪无法破坏。</p>
<h2>中毒症状</h2>
<p>中毒后有6-12小时的潜伏期，随后出现剧烈呕吐、腹泻等症状。之后进入假愈期，患者感觉好转，但肝损伤正在持续恶化，如不及时治疗，通常在4-7天后因肝衰竭死亡。</p>`,
    readTime: 8,
    publishDate: '2026-06-10',
  },
  {
    slug: 'amanita-phalloides',
    title: '毒鹅膏：全球致死率最高的蘑菇',
    category: 'common-poisonous',
    excerpt: '毒鹅膏（死亡帽）是全球蘑菇中毒死亡案例的首要原因，仅需半个菌盖即可致命，了解它的特征至关重要。',
    content: `<p>毒鹅膏（学名：Amanita phalloides），俗称"死亡帽"，是全球致死率最高的毒蘑菇。</p>
<h2>外观特征</h2>
<p>菌盖橄榄绿色至黄褐色，直径5-15厘米，表面有暗色纤维纹。菌褶白色。菌柄有菌环和明显的菌托。</p>
<h2>危险之处</h2>
<p>毒鹅膏的外观与某些可食用的草菇相似，容易被误采误食。仅需30克（约半个菌盖）就可能导致一个成年人死亡。</p>
<h2>地理分布</h2>
<p>在中国南方地区较为常见，常生长在阔叶林下，与栎树等形成菌根关系。每年夏秋季节是中毒高发期。</p>`,
    readTime: 9,
    publishDate: '2026-06-12',
  },
  {
    slug: 'galerina-marginata',
    title: '纹缘盔孢伞：木材上的隐形杀手',
    category: 'common-poisonous',
    excerpt: '纹缘盔孢伞常生长在腐朽木材上，外观与可食用的金针菇相似，含有与毒鹅膏相同的致命毒素。',
    content: `<p>纹缘盔孢伞（学名：Galerina marginata）是一种含有鹅膏毒肽的致命毒蘑菇。</p>
<h2>外观特征</h2>
<p>菌盖黄褐色至棕褐色，直径1-4厘米，边缘有明显条纹。菌褶黄褐色。菌柄有膜质菌环。</p>
<h2>与食用菌的混淆</h2>
<p>纹缘盔孢伞的外观与金针菇（Flammulina velutipes）很相似，两者都在秋冬季生长于朽木上。关键区别在于金针菇的孢子印是白色的，而纹缘盔孢伞的孢子印是锈褐色的。</p>
<h2>毒性</h2>
<p>含有与毒鹅膏相同的鹅膏毒肽，同样具有肝毒性。即使误食少量也可能致命。</p>`,
    readTime: 7,
    publishDate: '2026-06-18',
  },
  {
    slug: 'cortinarius',
    title: '丝膜菌属：潜伏期最长的肾毒性蘑菇',
    category: 'common-poisonous',
    excerpt: '丝膜菌属含有的奥来毒素具有极长的潜伏期，中毒症状可在食用后两周才出现，极易误诊。',
    content: `<p>丝膜菌属（Cortinarius）中的某些种类含有奥来毒素（orellanine），这是一种肾毒性毒素。</p>
<h2>特征识别</h2>
<p>丝膜菌属的一个典型特征是在菌盖边缘和菌柄之间有蛛丝状的丝膜结构，因此得名。菌盖颜色多样，从棕红色到紫色都有。</p>
<h2>最危险的特点</h2>
<p>奥来毒素中毒的潜伏期极长，可达2-17天。当症状出现时（口渴、腰痛、肾功能损害），患者可能已经忘记了吃过蘑菇，导致误诊率极高。</p>
<h2>预防建议</h2>
<p>由于丝膜菌属种类繁多且辨别困难，建议一般野外采摘者完全避开所有丝膜菌属的蘑菇。</p>`,
    readTime: 7,
    publishDate: '2026-06-22',
  },
  {
    slug: 'chlorophyllum-molybdites',
    title: '绿褶菇：最常见的胃肠炎型毒蘑菇',
    category: 'common-poisonous',
    excerpt: '绿褶菇是中国导致中毒事件最多的毒蘑菇之一，外观与可食用的高大环柄菇极其相似，容易混淆。',
    content: `<p>绿褶菇（学名：Chlorophyllum molybdites）是中国最常见的胃肠炎型毒蘑菇，每年都有大量误食中毒案例。</p>
<h2>外观特征</h2>
<p>菌盖白色至淡褐色，直径5-25厘米，表面有褐色鳞片。成熟后菌褶呈灰绿色，这是重要的鉴别特征。</p>
<h2>与食用菌的区别</h2>
<p>绿褶菇与可食用的高大环柄菇（Macrolepiota procera）外观极为相似。最关键的区别是孢子颜色：绿褶菇孢子印为灰绿色，高大环柄菇为白色。</p>
<h2>中毒症状</h2>
<p>食用后30分钟至3小时内出现剧烈呕吐、腹泻、腹痛等症状。虽然通常不会致命，但对老人和儿童可能造成严重脱水。</p>`,
    readTime: 6,
    publishDate: '2026-06-25',
  },
  {
    slug: 'amanita-muscaria',
    title: '毒蝇伞：童话中的经典毒蘑菇',
    category: 'common-poisonous',
    excerpt: '毒蝇伞因其红底白点的经典外观而广为人知，常出现在童话和游戏作品中。虽然致命性较低，但仍有毒性。',
    content: `<p>毒蝇伞（学名：Amanita muscaria）是最具辨识度的毒蘑菇，红底白点的外观深入人心。</p>
<h2>外观特征</h2>
<p>菌盖鲜红色，直径8-20厘米，表面散布白色至淡黄色的疣状鳞片。菌褶白色，菌柄白色，基部有鳞茎状菌托。</p>
<h2>毒性成分</h2>
<p>含有蝇蕈醇（muscimol）和鹅膏蕈氨酸（ibotenic acid），主要影响中枢神经系统。与毒鹅膏不同，毒蝇伞不含鹅膏毒肽，致死案例极为罕见。</p>
<h2>中毒症状</h2>
<p>食用后30分钟至2小时内出现症状，包括意识混乱、幻觉、肌肉抽搐、嗜睡等。大多数中毒者可以完全恢复。</p>`,
    readTime: 7,
    publishDate: '2026-06-28',
  },
  {
    slug: 'emergency-steps',
    title: '蘑菇中毒后黄金处理步骤：每一秒都关键',
    category: 'first-aid',
    excerpt: '发现或怀疑蘑菇中毒后，正确的紧急处理可以大大提高救治成功率。掌握这5个关键步骤，在紧急时刻能够救命。',
    content: `<p>蘑菇中毒后的前几个小时是救治的黄金时间。正确的紧急处理可以显著提高救治成功率。</p>
<h2>第一步：立即停止进食</h2>
<p>如果多人一起食用，要立即通知所有人停止进食，并收集剩余的蘑菇样本。</p>
<h2>第二步：催吐（需谨慎判断）</h2>
<p>在中毒后1-2小时内，如果患者意识清醒，可以考虑催吐。但注意：如果患者已出现意识模糊或昏迷，切勿催吐，以免呕吐物堵塞呼吸道。</p>
<h2>第三步：保留样本</h2>
<p>将剩余的蘑菇（包括煮熟的）和呕吐物保存好，这对医院确定毒素类型至关重要。</p>
<h2>第四步：立即就医</h2>
<p>不要等待症状出现！有些毒蘑菇的潜伏期长达6-12小时。立即前往最近的医院急诊科。</p>
<h2>第五步：告知信息</h2>
<p>告诉医生：食用了什么蘑菇、食用量、食用时间、何时出现什么症状。如果有剩余的蘑菇样本，一并提供给医生。</p>`,
    readTime: 6,
    publishDate: '2026-07-02',
  },
  {
    slug: 'symptoms-timeline',
    title: '毒蘑菇中毒症状时间表：何时出现什么症状',
    category: 'first-aid',
    excerpt: '不同毒蘑菇的中毒潜伏期和症状表现差异巨大。了解这些时间规律，有助于判断中毒类型和严重程度。',
    content: `<p>不同种类的毒蘑菇具有不同的中毒潜伏期和症状表现，了解这些规律有助于判断中毒类型。</p>
<h2>速发型（30分钟-3小时）</h2>
<p>主要由胃肠炎型毒蘑菇引起，如绿褶菇。症状包括恶心、呕吐、腹泻、腹痛。通常预后较好。</p>
<h2>中等潜伏期（6-12小时）</h2>
<p>这是最危险的类型，主要由含鹅膏毒肽的蘑菇引起。初期症状类似胃肠炎，但之后会进入假愈期，肝损伤在持续恶化。</p>
<h2>迟发型（2-17天）</h2>
<p>丝膜菌属蘑菇引起的肾毒性中毒，潜伏期极长。当出现口渴、腰痛等症状时，肾脏可能已经严重受损。</p>`,
    readTime: 7,
    publishDate: '2026-07-08',
  },
  {
    slug: 'hospital-guide',
    title: '蘑菇中毒就医指南：去哪家医院、挂什么科',
    category: 'first-aid',
    excerpt: '蘑菇中毒后应该去什么医院？挂哪个科室？需要做哪些检查？本指南为你梳理清楚就医全流程。',
    content: `<p>蘑菇中毒后如何正确就医，直接关系到救治效果。以下是完整的就医指南。</p>
<h2>选择合适的医院</h2>
<p>首选有中毒救治中心或急诊科的三甲医院。某些地区的疾控中心也提供蘑菇中毒的咨询和救治指导。</p>
<h2>挂什么科</h2>
<p>直接挂急诊科。医生会根据情况转诊至消化内科、肝病科或肾内科。</p>
<h2>需要做的检查</h2>
<p>通常需要进行血常规、肝功能、肾功能、凝血功能等检查。根据具体中毒类型，可能还需要其他专项检查。</p>
<h2>全国中毒救治热线</h2>
<p>国家中毒控制中心热线可以为医院提供专业的救治指导建议。到达医院后可以让医生拨打咨询。</p>`,
    readTime: 5,
    publishDate: '2026-07-12',
  },
  {
    slug: 'home-remedies-myth',
    title: '蘑菇中毒自救误区：大蒜、银器都不能解毒',
    category: 'first-aid',
    excerpt: '关于蘑菇中毒的民间偏方层出不穷，大蒜验毒、银器试毒等方法不仅无效，反而可能延误最佳救治时机。',
    content: `<p>民间流传着大量关于蘑菇中毒自救的"偏方"，但绝大多数都是错误的，甚至可能延误救治。</p>
<h2>误区一：大蒜能解毒</h2>
<p>大蒜变色与蘑菇毒性没有任何科学关联。无论是煮大蒜还是用大蒜擦拭蘑菇，都不能作为判断毒性的依据。</p>
<h2>误区二：银器试毒</h2>
<p>银器变黑是因为与硫化物反应，而大多数蘑菇毒素不含硫。银器测试完全不能检测蘑菇毒性。</p>
<h2>误区三：喝牛奶或蛋清解毒</h2>
<p>牛奶和蛋清对某些毒素有一定吸附作用，但不能替代正规医疗。蘑菇中毒后唯一正确的做法是立即就医。</p>
<h2>误区四：煮久一点就能去毒</h2>
<p>鹅膏毒肽等致命毒素耐高温，普通烹饪温度和时间无法分解。有些毒素甚至在煮沸数小时后依然保持毒性。</p>`,
    readTime: 6,
    publishDate: '2026-07-18',
  },
  {
    slug: 'children-special',
    title: '儿童蘑菇中毒：特别注意事项',
    category: 'first-aid',
    excerpt: '儿童体重轻、器官发育不完全，对蘑菇毒素更为敏感。了解儿童蘑菇中毒的特殊性，做好预防和应急准备。',
    content: `<p>儿童是蘑菇中毒的高风险人群，需要特别的关注和防护措施。</p>
<h2>为什么儿童风险更高？</h2>
<p>儿童体重轻，同等剂量的毒素造成的伤害更大。同时儿童的肝脏和肾脏解毒能力尚未完全发育，更容易受到毒素损伤。</p>
<h2>预防措施</h2>
<p>带孩子野外活动时，教育他们不要触摸或采摘任何蘑菇。家中的院子如果长了蘑菇，要及时清除，防止幼儿误食。</p>
<h2>中毒处理</h2>
<p>儿童蘑菇中毒的处理原则与成人相同，但更要争分夺秒。儿童脱水更快，需要更积极的补液治疗。</p>`,
    readTime: 5,
    publishDate: '2026-07-22',
  },
  {
    slug: 'long-term-recovery',
    title: '蘑菇中毒后的长期康复与随访',
    category: 'first-aid',
    excerpt: '蘑菇中毒不仅需要紧急救治，更需要长期的康复和随访。了解肝脏和肾脏功能的恢复过程，做好长期健康管理。',
    content: `<p>严重的蘑菇中毒即使度过了急性期，也需要长期的康复管理和随访。</p>
<h2>肝功能恢复</h2>
<p>鹅膏毒肽中毒导致的肝损伤，在及时救治后通常可以部分或完全恢复。但恢复期可能长达数月到一年。期间需要定期检查肝功能。</p>
<h2>肾功能监测</h2>
<p>奥来毒素可能导致永久性肾损伤。部分患者需要长期透析治疗。定期监测肾功能至关重要。</p>
<h2>心理康复</h2>
<p>经历过严重中毒的患者可能留下心理创伤。如有需要，应寻求专业的心理咨询帮助。</p>`,
    readTime: 6,
    publishDate: '2026-07-25',
  },
  {
    slug: 'essential-equipment',
    title: '野外采菇必备装备清单',
    category: 'foraging-guide',
    excerpt: '安全的野外采菇体验需要合适的装备。从篮子到刀具，从图鉴到手电，这份清单帮你做好万全准备。',
    content: `<p>准备充足的装备是安全采菇的第一步。以下是野外采菇的完整装备清单。</p>
<h2>基础装备</h2>
<p>编织篮（透气性好，孢子可以散落传播）、小刀（用于挖取完整蘑菇）、刷子（清洁蘑菇表面泥土）、纸袋（分别装不同种类的蘑菇）。</p>
<h2>安全装备</h2>
<p>手套、防滑鞋、雨衣、手电筒、指南针（或GPS设备）、手机和充电宝。</p>
<h2>鉴别工具</h2>
<p>蘑菇图鉴书籍、放大镜、笔记本和笔（记录发现地点和特征）、照相机（拍摄蘑菇照片用于后期鉴别）。</p>`,
    readTime: 5,
    publishDate: '2026-08-01',
  },
  {
    slug: 'best-seasons',
    title: '最佳采菇季节：不同地区的蘑菇生长日历',
    category: 'foraging-guide',
    excerpt: '不同种类的蘑菇有各自的生长季节。了解中国不同地区的最佳采菇时间，提高野外收获的同时确保安全。',
    content: `<p>蘑菇的生长与气温、湿度密切相关。不同地区和季节出产的蘑菇种类各不相同。</p>
<h2>春季（3-5月）</h2>
<p>羊肚菌是最著名的春季蘑菇，此外还有春生鹅膏等。南方地区春季雨水充沛，蘑菇种类繁多。</p>
<h2>夏季（6-8月）</h2>
<p>牛肝菌、鸡枞菌等大量出现。但夏季也是毒蘑菇最活跃的季节，需要格外小心。</p>
<h2>秋季（9-11月）</h2>
<p>松茸、榛蘑、猴头菇等名贵食用菌的主要季节。同时也是毒鹅膏的高发季节。</p>
<h2>冬季（12-2月）</h2>
<p>北方地区蘑菇较少，但南方仍有金针菇、平菇等冬季蘑菇。</p>`,
    readTime: 6,
    publishDate: '2026-08-03',
  },
  {
    slug: 'safe-harvesting',
    title: '安全采摘技巧：从识别到采集的完整流程',
    category: 'foraging-guide',
    excerpt: '正确采摘蘑菇不只是"摘下来"那么简单。了解挖取技巧、现场鉴别方法和对环境的尊重，做一个负责任的采菇人。',
    content: `<p>掌握了鉴别知识后，正确的采摘方法同样重要。</p>
<h2>现场鉴别</h2>
<p>在采摘前，先做完整的现场观察：拍照记录蘑菇的生长环境、拍摄菌盖正面和侧面、菌褶、菌柄、菌托等各个角度。只有100%确认是已知可食用种类才采摘。</p>
<h2>正确挖取</h2>
<p>用小刀从菌柄基部挖取完整蘑菇，不要只掐断菌柄。菌柄基部是否有菌托是鉴别鹅膏属蘑菇的关键特征。</p>
<h2>分装保存</h2>
<p>不确定的种类要和已知可食用的种类分开装袋，避免交叉污染。每种蘑菇单独用纸袋或蜡纸包裹。</p>
<h2>环保采摘</h2>
<p>不要采摘过小的蘑菇，让它们继续生长。不要在同一地点采摘过多，保留一些蘑菇让其释放孢子繁衍。</p>`,
    readTime: 6,
    publishDate: '2026-08-05',
  },
  {
    slug: 'storage-tips',
    title: '蘑菇保存方法：延长新鲜度的技巧',
    category: 'foraging-guide',
    excerpt: '新鲜蘑菇的保鲜期很短，正确的保存方法可以让美味延续。了解冷藏、干燥、冷冻等不同保存方式。',
    content: `<p>新鲜采摘的蘑菇如果不及时处理，很快就会变质。掌握正确的保存方法很重要。</p>
<h2>冷藏保存</h2>
<p>用纸袋或透气的容器装蘑菇放入冰箱，不要用塑料袋密封。大多数新鲜蘑菇可以在冰箱中保存3-7天。</p>
<h2>干燥保存</h2>
<p>切片后用烘干机或日晒干燥，干燥后的蘑菇可以保存数月甚至一年。使用前用温水泡发即可。</p>
<h2>冷冻保存</h2>
<p>先将蘑菇焯水或炒熟，冷却后装袋冷冻。直接冷冻生蘑菇会影响口感。冷冻蘑菇可保存3-6个月。</p>`,
    readTime: 5,
    publishDate: '2026-08-07',
  },
  {
    slug: 'regional-guide',
    title: '中国各地区常见蘑菇种类指南',
    category: 'foraging-guide',
    excerpt: '从东北到云南，从四川到福建，中国不同地区孕育着不同的蘑菇种类。本土化指南帮你了解身边的蘑菇。',
    content: `<p>中国地域辽阔，不同地区的气候和植被孕育了各具特色的蘑菇种类。</p>
<h2>东北地区</h2>
<p>榛蘑、元蘑、猴头菇等是东北的特色食用菌。同时也有毒鹅膏分布，需要警惕。</p>
<h2>西南地区（云南、四川）</h2>
<p>中国蘑菇种类最丰富的地区。松茸、鸡枞菌、牛肝菌等名贵食用菌种类繁多，但毒蘑菇种类也最多，是中毒高发区。</p>
<h2>华南地区</h2>
<p>温暖湿润的气候适合各种蘑菇生长。致命白毒伞在广东、广西等地常见。</p>
<h2>西北地区</h2>
<p>蘑菇种类相对较少，但仍有独特的种类如阿魏菇等。</p>`,
    readTime: 7,
    publishDate: '2026-08-10',
  },
  {
    slug: 'legal-regulations',
    title: '野外采摘的法律法规与注意事项',
    category: 'foraging-guide',
    excerpt: '野外采摘蘑菇不仅要考虑安全问题，还要遵守相关法律法规。了解自然保护区、国家公园的采摘规定。',
    content: `<p>在中国，野外采摘蘑菇在大多数情况下是允许的，但在特定区域有明确的禁止规定。</p>
<h2>自然保护区和国家公园</h2>
<p>在自然保护区、国家公园的核心区内禁止采摘任何植物（包括蘑菇）。在实验区或一般控制区，请查阅当地管理规定。</p>
<h2>私人林地</h2>
<p>未经土地所有者许可，不得进入私人林地采摘。即使蘑菇是野生的，也属于土地所有者的财产。</p>
<h2>保护物种</h2>
<p>一些珍稀蘑菇种类受到法律保护，采摘可能违反《野生植物保护条例》。如不确定，请勿采摘。</p>
<h2>建议</h2>
<p>建议在允许采摘的公共林地或获得许可的私人林地采摘。遵守"不留痕迹"的户外原则，保护自然环境。</p>`,
    readTime: 5,
    publishDate: '2026-08-12',
  },
];

export const galleryImages = [
  { slug: 'amanita-comparison', title: '鹅膏属毒蘑菇与食用菌对比图鉴', category: 'mushroom-gallery', seq: 'amanita-compare' },
  { slug: 'bolete-comparison', title: '牛肝菌类有毒与可食用种类分辨', category: 'mushroom-gallery', seq: 'bolete-compare' },
  { slug: 'russula-comparison', title: '红菇属可食与有毒种类对比', category: 'mushroom-gallery', seq: 'russula-compare' },
  { slug: 'agaricus-comparison', title: '蘑菇属常见有毒与食用种类', category: 'mushroom-gallery', seq: 'agaricus-compare' },
  { slug: 'spring-species', title: '春季常见毒蘑菇识别图鉴', category: 'mushroom-gallery', seq: 'spring-mush' },
  { slug: 'autumn-species', title: '秋季高发毒蘑菇种类汇总', category: 'mushroom-gallery', seq: 'autumn-mush' },
];

export const faqs = [
  {
    question: '毒蘑菇测试最可靠的方法是什么？',
    answer: '最可靠的方法是综合使用多种鉴别手段：外观观察、孢子印测试、化学反应测试，并结合权威图鉴进行比对。单一方法可能存在误差，综合判断才能提高准确性。如果不确定，绝对不要食用。',
  },
  {
    question: '所有颜色鲜艳的蘑菇都有毒吗？',
    answer: '这是一个常见的误区。颜色鲜艳并不代表有毒，同样，颜色普通的蘑菇也可能剧毒。例如致命白毒伞通体雪白却剧毒无比，而颜色鲜艳的红菇有些种类是可食用的。判断蘑菇是否有毒需要综合多方面特征。',
  },
  {
    question: '用银器或大蒜煮蘑菇能测出毒性吗？',
    answer: '不能！这是最危险的民间误区之一。银器变色是因为与硫化物反应，大多数蘑菇毒素不含硫化物。大蒜变色同样与蘑菇毒性无关。请勿使用任何未经科学验证的"土方法"来判断蘑菇毒性。',
  },
  {
    question: '煮蘑菇时间久一点能去毒吗？',
    answer: '部分蘑菇毒素可以通过充分加热分解，但鹅膏毒肽等致命毒素具有极强的热稳定性，即使在100℃下煮沸数小时也无法被破坏。因此不能依赖"多煮一会儿"的方法来确保安全。',
  },
  {
    question: '野外采摘蘑菇有哪些必须遵守的安全准则？',
    answer: '核心安全准则：1）只采摘你100%确认认识的食用菌；2）不确定的蘑菇绝不食用；3）采摘时保留完整蘑菇（包括菌托），便于鉴别；4）不同种类分开存放避免交叉；5）食用前再次逐朵检查确认；6）首次尝试新种类只吃少量，保留样本；7）告诉家人你吃了什么蘑菇以及采摘地点。',
  },
  {
    question: '吃了毒蘑菇后多久会出现症状？',
    answer: '不同类型的毒蘑菇中毒潜伏期差异很大。胃肠炎型通常在30分钟至3小时内出现症状；肝毒性（如毒鹅膏）潜伏期为6-12小时，之后有假愈期；肾毒性（如丝膜菌属）潜伏期可长达2-17天。潜伏期越长，往往意味着毒素越危险。',
  },
  {
    question: '蘑菇中毒后应该怎么做？',
    answer: '立即停止食用→保留剩余蘑菇样本→尽快前往最近的医院急诊科，不要等待症状出现。如果意识清醒且食用时间在1-2小时内可以催吐，但意识模糊者禁止催吐。带上剩余的蘑菇样本（生的和熟的）以及呕吐物样本到医院，这对诊断和治疗至关重要。',
  },
  {
    question: '中国最常见的致命毒蘑菇有哪些？',
    answer: '中国最常见的致命毒蘑菇包括：致命白毒伞（Amanita virosa）、毒鹅膏/死亡帽（Amanita phalloides）、纹缘盔孢伞（Galerina marginata）、亚稀褶黑菇（Russula subnigricans）等。这些蘑菇的共同特点是含有鹅膏毒肽等强毒性物质，少量即可致命。',
  },
];

export const myths = [
  {
    title: '颜色鲜艳的蘑菇才有毒',
    truth: '许多剧毒蘑菇颜色朴素。致命白毒伞通体雪白，毒鹅膏呈橄榄绿，都是不显眼的颜色。',
    icon: 'ri-palette-line',
  },
  {
    title: '虫子吃过的蘑菇无毒',
    truth: '昆虫的生理结构与人完全不同。致命鹅膏上常有虫咬痕迹，但对人剧毒。',
    icon: 'ri-bug-line',
  },
  {
    title: '银器变黑就说明有毒',
    truth: '银器变黑是与硫化物反应，与蘑菇毒素无关。这是一种没有任何科学依据的测试方法。',
    icon: 'ri-close-circle-line',
  },
  {
    title: '煮久了就能去毒',
    truth: '鹅膏毒肽等致命毒素具有极强的热稳定性，煮沸数小时也无法分解。',
    icon: 'ri-fire-line',
  },
  {
    title: '和大蒜一起煮变色就是有毒',
    truth: '大蒜变色同样与蘑菇毒性无关，变色反应由蘑菇中的酶和其他化合物引起。',
    icon: 'ri-restaurant-line',
  },
  {
    title: '长在干净地方的蘑菇无毒',
    truth: '蘑菇的毒性与其生长环境无关，是由其基因决定的。毒蘑菇可以长在任何地方。',
    icon: 'ri-landscape-line',
  },
];